export const getBaselineTemplate = baselineValue => `<div class='gantt_tree_content baseline_content'><div class='text_value'>${baselineValue}</div></div>`;
export const getDefaultTemplate = cellValue => `<div class='gantt_tree_content'><div class='text_value'>${cellValue}</div></div>`;
export const getDefaultTemplateWithTooltip = (cellValue, tooltipKey) => `<div class='gantt_tree_content'><div class='tooltip-gantt no_pointer text_value' data-y='-4' data-key='${tooltipKey}' data-position='top'>${cellValue}</div></div>`;
export const getTemplateWithClass = (cellValue, className) => `<div class='gantt_tree_content'><div class='${className}'>${cellValue}</div></div>`;

export const getIndentTree = (instance, task, column, isButton) => {
  let tree = '';

  if (column.tree) {
    let j = 0;

    if (instance.config.multiview && isButton && task.$level === 2) {
      j = 2;
    }

    for (; j < task.$level; j++) {
      tree += instance.templates.grid_indent(task);
    }

    if (instance.hasChild(task.id)) {
      tree += instance.templates.grid_open(task);
    } else {
      tree += instance.templates.grid_blank(task);
    }
  }

  return tree;
};
